module.exports = __webpack_public_path__ + "static/media/thumbnail-finca-danny.fec9cba6.jpg";